import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/cf_block1.png';
import _imports_1 from '@/assets/cf_balance.jpg';
import _imports_2 from '@/assets/cf_friend.png';
const _withScopeId = n => (_pushScopeId("data-v-2a93c394"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = {
  class: "text-box d-flex jc-between ai-center main-width"
};
const _hoisted_4 = {
  class: "text-white text-left"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logotitle fs-m text-orange"
}, "碳友团", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title pt-10 pb-20 fw-b fs-xl"
}, "成就一批碳界领军人物！", -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_9 = {
  class: "block block2"
};
const _hoisted_10 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-l title pb-40"
}, "成为碳友有什么好处？", -1));
const _hoisted_12 = {
  class: "pl-5 item_content"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_14 = {
  class: "block block4"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "main-width content_box text-white"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "碳友等级"), /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-m pt-10 pb-40"
}, "提升自己在碳手印领域的影响力")], -1));
const _hoisted_16 = {
  class: "award_list d-flex jc-between main-width"
};
const _hoisted_17 = {
  class: "img_box"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "title_box"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_box_subtitle"
}, "WELL碳手印活动", -1));
const _hoisted_21 = {
  class: "img_box_title"
};
const _hoisted_22 = {
  class: "item-bottom text-center"
};
const _hoisted_23 = {
  class: "fw-b pt-20 text-white"
};
const _hoisted_24 = {
  class: "fs-xs pt-10 text-white"
};
const _hoisted_25 = {
  class: "block block3"
};
const _hoisted_26 = {
  class: "main-width main_box d-flex jc-between ai-center"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l text-orange pb-20 fw-b"
}, "成为碳友需具备哪些条件？", -1));
const _hoisted_28 = {
  class: "d-flex jc-between pt-20"
};
const _hoisted_29 = {
  class: "text-box"
};
const _hoisted_30 = {
  class: "pb-10 item_title"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
import { Select } from '@element-plus/icons-vue';
import { onMounted } from 'vue';
import wx from 'weixin-js-sdk';
import { useStore } from 'vuex';
export default {
  __name: 'CarbonFriend',
  setup(__props) {
    const store = useStore();
    const textData = {
      block1: '基于初心和使命，持续聚合有志于在碳手印<br>领域有所作为的高能级人士！',
      block2: '从教室到会议室，碳手印学院的赋能官们<br>正在引领我们走向更加美好、健康的未来。',
      block3: '在全球范围内，<br>我们的教育工作者正在引领运动，<br>推动健康低碳的场所。',
      block5: '超过80%的优秀赋能官从WELL碳手印标准开始，<br>去看看我们的标准吧。'
    };
    const balanceList = [{
      content: '免费参加碳手印公益培训',
      color: '#9cbc11'
    }, {
      content: '获得碳手印项目推荐资格',
      color: '#0d6269'
    }, {
      content: '成功推荐项目可获得平台碳权益',
      color: '#0896d4'
    }, {
      content: '获得优质人脉资源',
      color: '#f98514'
    }];
    const signupList = [{
      title: '① 认同碳手印组织及WELL碳手印理念',
      content: '准备好个人信息。'
    }, {
      title: '② 品行端正，3年内无不良行为记录',
      content: '组委会分期定额计划组建碳友团。'
    }, {
      title: '③ 了解碳友团及碳友相关政策',
      content: '点击下方链接申请加入碳友团。'
    }, {
      title: '④ 有时间、精力及意愿为碳手印活动贡献力量',
      content: '点击下方链接申请加入碳友团。'
    }];
    const awardsList = [{
      title: '星级碳友',
      content: '已成功推荐过项目参与碳手印评级活动的个人',
      url: require('@/assets/logo/blue_logo_bg.png')
    }, {
      title: '银级碳友',
      content: '推荐项目≥3个并获得银级碳友奖章的个人',
      url: require('@/assets/logo/sliver_logo_bg.png')
    }, {
      title: '金级碳友',
      content: '推荐项目≥5个并获得金级碳友奖章的个人',
      url: require('@/assets/logo/gold_logo_bg.png')
    }];
    const toApplyPage = () => {
      location.href = "https://f.wps.cn/g/pfpNwRCw/";
    };
    const wxFunc = function () {
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        const params = store.state.VUEX_SHARECONFIG.carbonFriend;
        wx.updateAppMessageShareData({
          ...params,
          success: function () {
            // 设置成功
          }
        });
      });
    };
    onMounted(() => {
      wxFunc();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", {
        class: "slogantext pb-20 fs-s",
        innerHTML: textData.block1
      }, null, 8, _hoisted_7), _createVNode(_component_el_button, {
        class: "btn text-purple",
        color: "#fff",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为碳友")]),
        _: 1
      }), _hoisted_8])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_hoisted_11, _createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(balanceList, (item, idx) => {
        return _createElementVNode("div", {
          class: "d-flex ai-center pb-10",
          key: idx
        }, [_createVNode(_component_el_icon, {
          color: item.color
        }, {
          default: _withCtx(() => [_createVNode(_unref(Select))]),
          _: 2
        }, 1032, ["color"]), _createElementVNode("div", _hoisted_12, _toDisplayString(item.content), 1)]);
      }), 64))])]), _hoisted_13])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(awardsList, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item",
          key: idx
        }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(item.title), 1)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.content), 1)])]);
      }), 64))])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(signupList, (item, idx) => {
        return _createElementVNode("div", {
          class: "",
          key: idx
        }, [_createElementVNode("div", _hoisted_30, _toDisplayString(item.title), 1)]);
      }), 64)), _createVNode(_component_el_button, {
        class: "btn",
        onClick: toApplyPage
      }, {
        default: _withCtx(() => [_createTextVNode("申请成为碳友")]),
        _: 1
      })])])]), _hoisted_31])])]);
    };
  }
};